import axios from "axios";
import { API_HTTP_CONTEXT, ENV } from "constants/api";
import { useAuthStore } from "stores/authStore";

const axiosInstance = axios.create({
  baseURL: API_HTTP_CONTEXT,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = ENV
    ? useAuthStore.getState().token
    : "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIwMDJAYS5hIiwiYXV0aCI6W3siYXV0aG9yaXR5IjoiUk9MRV9NIn1dLCJ1c24iOjEwMDIwMjUxLCJ1c2VyTm0iOiJBYSIsInBhc3N3ZFVwZGF0ZUR0IjoxNzEwMjI2NTYxMDAwLCJnZW5kZXIiOiJGIiwicHJvZmlsZXMiOiJkZXYiLCJ0aW1lem9uZSI6IkFzaWEvU2VvdWwiLCJpYXQiOjE3NzQ5MTg5NzUsImV4cCI6MTgwNjQ1NDk3NX0.q0iMGVAeEyTK4B5nER73ntpfghf4CXRZy7YsQ5r0h8g";

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default axiosInstance;
